export default {
  sidebar: {
    tracks: 'Tracks',
    releases: 'Releases',
    projects: 'Projects',
  },
  tracks: {
    heading: 'Tracks',
    liked: 'Liked Tracks',
    studio: 'Studio Tracks',
  },
  releases: {
    heading: 'Releases',
  },
  projects: {
    heading: 'Studio Projects',
    deleteProject: 'Delete Project',
    emptyState: 'You’ve not created any project yet.',
    getProjectsErrorMessage: 'Request project error',
    tooltip: {
      edit: 'Edit in Studio',
    },
  },
  newReleaseModal: {
    modalTitle: 'New Release',
    generateTrackTitle: 'Generate new track',
    generateTrackSubTitle: 'Use AI to create music for release',
    releaseFromLibraryTitle: 'Release from library',
    releaseFromLibrarySubTitle: 'Release a track from your library',
    uploadTitle: 'Upload and release',
    uploadSubTitle: 'Use your own audio for release',
  },
  studioSongs: {
    getStudioSongsErrorMessage:
      'An unkown error occurred. Please contact our support to receive further help.',
    deleteSong: 'Delete Song',
    emptyState: 'No studio tracks exported yet.',
  },
  confirmDeletionModal: {
    title: {
      deleteProject: 'Delete project?',
      deleteTrack: 'Delete track?',
    },
    description: {
      project:
        'Are you sure you want to delete this project? This action cannot be undone.',
      track:
        'Are you sure you want to delete this track? This action cannot be undone.',
    },
    cancel: 'Cancel',
    delete: 'Delete',
  },
};
